import Title from "components/Title";
import React, { useState, useRef } from "react";
import Section from "Section";
import ROW_ONE from "./ROW_ONE";
import ROW_TWO from "./ROW_TWO";
import EGGWARD_IMAGE from "./headshots/eggward.png";
import CARPET_IMGE from "./headshots/carpet.png";
export default function MeetTheTeam() {
  const [name, setname] = useState("");
  const [role, setrole] = useState("");
  let setName = (n, r) => {
    setname(n);
    setrole(r);
  };
  let resetName = () => {
    setname("");
    setrole("");
  };
  return (
    <Section bcolor={"#fff"}>
      <div className="meet-anchor" id="team" />
      <div className="meet-con">
        <Title text={"Meet the Team"} />
        <div className="meet-present">
          {" "}
          {name && `Presenting: ${name}, ${role}`}
        </div>
        <Slider
          row={ROW_ONE}
          de={"one"}
          setName={setName}
          resetName={resetName}
        />
        <Slider
          row={ROW_TWO}
          de={"two"}
          setName={setName}
          resetName={resetName}
        />
        <Eggward />
      </div>
    </Section>
  );
}

function Eggward() {
  return (
    <div className="meet-egg">
      <img src={EGGWARD_IMAGE} alt="" />
      <img src={CARPET_IMGE} alt="" />
    </div>
  );
}
function Slider({ row, de, resetName, setName }) {
  const refD = useRef(null);
  const IMAGE_WIDTH = 125;
  row = [...row, ...row, ...row];
  const SliderBar = () => (
    <div className="slide-bar">
      {[...new Array(6)].map(() => (
        <div />
      ))}
    </div>
  );
  return (
    <div className="slider">
      <div className={`slide-track ${de}`} ref={refD}>
        {row.map(({ name, role, image }) => (
          <div
            className="slide-frame"
            key={name}
            onMouseEnter={() => setName(name, role)}
            onClick={() => setName(name, role)}
            onMouseLeave={resetName}
          >
            <SliderBar />
            <img
              src={image}
              height={IMAGE_WIDTH}
              width={IMAGE_WIDTH}
              alt={name}
            />
            <SliderBar />
          </div>
        ))}
      </div>
    </div>
  );
}
